export class NFeEntradaEstoqueExcluirRequest {
  justificativa = '';
}
